import {Component, OnInit} from '@angular/core';
import {Project} from "../../../../../Models/project";
import {ProjectService} from "../../../../../Services/project.service";
import {environment} from "../../../../../../environments/environment";


@Component({
  selector: 'app-our-data-project',
  templateUrl: './our-data-project.component.html',
  styleUrls: ['./our-data-project.component.scss']
})
export class OurDataProjectComponent implements OnInit {
    projectsData: Project[] = [];

    constructor(private projectServ: ProjectService) {
    }

    ngOnInit(): void {
        this.projectServ.getAllProjects().subscribe(projects => {
            this.projectsData = projects;
        });
    }

    protected readonly environment = environment;
}
